import { jsx as _jsx } from "react/jsx-runtime";
import { Info, InfoPresentation, Size } from '@transferwise/components';
import { FormattedMessage } from 'react-intl';
import providerDisclaimerStyles from './ProviderDisclaimers.module.less';
const RevolutDisclaimer = () => {
    return (_jsx("div", Object.assign({ className: providerDisclaimerStyles.providerDisclaimer, "data-testid": "revolut-disclaimer" }, { children: _jsx(Info, { title: _jsx(FormattedMessage, { id: "revolut-disclaimer-title" }), content: _jsx(FormattedMessage, { id: "revolut-disclaimer-body", values: {
                    learnMoreLink: function (...chunks) {
                        return (_jsx("a", Object.assign({ href: "https://wise.com/gb/compare/revolut-vs-wise", target: "_blank", rel: "noreferrer" }, { children: chunks })));
                    },
                } }), presentation: InfoPresentation.POPOVER, size: Size.LARGE }) })));
};
export default RevolutDisclaimer;
